export class LatLng {
    constructor(lat, lng) {
        this.lat = lat;
        this.lng = lng;
    }
    toGoogleMapsLatLng() {
        return new google.maps.LatLng(this.lat, this.lng);
    }
}
